/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_BtnInputs */

const en_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const fr_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer`)
};

const de_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const it_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importare`)
};

const ru_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт`)
};

const es_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

const zh_cn2_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进口`)
};

const ja_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入`)
};

const hi_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात`)
};

const pt_pt2_import_btn = /** @type {(inputs: Import_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

/**
* | output |
* | --- |
* | "Import" |
*
* @param {Import_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_btn = /** @type {((inputs?: Import_BtnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_BtnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_import_btn(inputs)
	if (locale === "de") return de_import_btn(inputs)
	if (locale === "it") return it_import_btn(inputs)
	if (locale === "ru") return ru_import_btn(inputs)
	if (locale === "es") return es_import_btn(inputs)
	if (locale === "zh-CN") return zh_cn2_import_btn(inputs)
	if (locale === "ja") return ja_import_btn(inputs)
	if (locale === "hi") return hi_import_btn(inputs)
	if (locale === "pt-PT") return pt_pt2_import_btn(inputs)
	return en_import_btn(inputs)
});